module.exports = __webpack_public_path__ + "static/icon_z.b33e7192.png";